import type { Locale } from 'lib/i18n/types';
import { DEFAULT_LOCALE } from 'lib/i18n/translations';
import { getBrandName } from 'lib/i18n/brandName';

// TODO delete when page descriptions is refactored
export default function getNetworkTitle(locale: Locale = DEFAULT_LOCALE) {
  return `${ getBrandName(locale) } Explorer`;
}
